// extracted by mini-css-extract-plugin
module.exports =  {"root":"_0bc5e8de02--root--W3pBd","rating":"_0bc5e8de02--rating--d_che","reviews-count":"_0bc5e8de02--reviews-count--DywEs","dot":"_0bc5e8de02--dot--Nv6ew"};